import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { Maksutapa } from '@lemon/core-firebase/model/tosite'
import { Observable, Subject } from 'rxjs'
import { map, takeUntil } from 'rxjs/operators'
import { TositeService } from '../../../_angular/service/tosite/tosite.service'

interface Maksutapavaihtoehto {
  id: number
  otsikko: string
  kuva: SafeUrl
}

@Component({
  selector: 'app-maksutapa-valinta',
  templateUrl: './maksutapa-valinta.component.html',
  styleUrls: ['./maksutapa-valinta.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaksutapaValintaComponent implements OnInit, OnDestroy {
  @Input() valittu: number | null = null
  @Input() virhe = ''
  @Input() lukittu = false
  @Output() valittuChange = new EventEmitter<number>()

  private _ngUnsubscribe = new Subject<void>()

  maksutavatObservable: Observable<Maksutapavaihtoehto[]>

  constructor(
    private _tositeService: TositeService,
    private _sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.maksutavatObservable = this._tositeService.maksutavatObservable.pipe(
      takeUntil(this._ngUnsubscribe),
      map((maksutavat: Maksutapa[]) => {
        return maksutavat
          .filter(m => m.a)
          .sort((a, b) => a.o - b.o)
          .map(m => ({
            id: m.i,
            otsikko: m.l,
            kuva: this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + m.img),
          }))
      }),
    )
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  valitseMaksutapa(id: number) {
    this.valittuChange.emit(id)
  }
}
